

import ShowMoreText from 'react-show-more-text';
import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox, INTER } from '@brg/ui';
import { LayoutConst } from "../../../core";

export const ShowMoreContent = styled(ShowMoreText)<{importantStyles?: boolean, isOnlines?: boolean, breakSpace?: boolean, designer?: boolean }>`
        flex-direction: column;
        width: 100%;
        
        font-size: 20px;
        line-height: 28px;

        a {
            // color: ${p =>  p.theme.designerPage.noProjectBlock.avatar.bg};
            color: #909090;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            font-style: normal;
            transition: color 0.2s;

                &:hover {
                // color: ${({ theme }) => theme?.navigationBar?.btns?.showMore?.hover?.color || Colors.geoWhite47};
                color: #545453;
                transition: color 0.2s;
            }
        }
        @media(max-width: ${LayoutConst.screen.l}px) {
           &, & a {
                font-size: 17px;
                line-height: 22px;
           }            
        }
        ${({designer}) => designer && css`
            @media(max-width: ${LayoutConst.screen.m}px) {
                // width: 680px;
                min-width: auto;
            }
            @media(max-width: ${LayoutConst.screen.sm}px) {
                width: 100%;
            }
        `}
         
    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-style: normal;
        color: ${({ theme }) => theme.app.text};
        ${p => p.breakSpace && css`
            white-space: break-spaces;
        `};
         &:last-of-type {
            white-space: normal;
        }
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        ${p => p.importantStyles ? css`
            span {
                font-size: 17px;
                line-height: 22px;
                font-family: 'Inter';
                font-weight: 400;
            }
        `: null};
        ${p => p.isOnlines ? css`
            span {
                font-weight: 500;
                font-style: normal;
                color: rgba(0, 0, 0, 1);
                font-family: Montserrat;
                font-size: 20px;
                letter-spacing: 0px;
                line-height: 28px;
            }
        `: null}

        ${p => p.isOnlines ? css`
        span {
            font-weight: 500;
            font-style: normal;
            color: rgba(0, 0, 0, 1);
            font-family: Montserrat;
            font-size: 20px;
            letter-spacing: 0px;
            line-height: 28px;
        }
    `: null}
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;

        &, & a, & span {
           font-size: 15px;
           line-height: 20px;
        }
    }
`;

export const LinkWrapper = styled.div`
    &:hover {
        svg path {
            fill: ${p => p?.theme.designerPage.textColor};
            transition: 0.2s fill;
        }
    }
`;

export const AboutTextWrapper = styled(FlexBox)<{isLoading?: boolean}>`
`;

export const ProfileTitleSubtitle = styled.div`
  margin-top: 8px;
  color: ${Colors.galBlack100};
  ${INTER.F_17_22_Reg};
  letter-spacing: -0.34px;
`;

export const ProfileTitleSubtitleBold = styled.span`
  font-weight: 600;
`;

export const AboutText = styled(FInter.TextDiv)`
        width: 100%;
        font-size: 17px;
        line-height: 22px;
        margin-top: 24px;
        a {
            font-size: 17px;
            line-height: 22px;
        }
        
        @media (max-width: ${LayoutConst.screen.l}px){
                font-size: 13px;
                line-height: 16px;
                font-weight: 400;
                a {
                    font-size: 13px;
                    line-height: 16px;
                }
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px){
            margin-top: 16px;
        }
`

export const URL = styled(FInter.SmallTextBold)`
    display: none;
    color: ${({theme}) => theme.link.default};
    margin-left: 4px;
    font-size: 17px;
    line-height: 22px;
    // @media (max-width: ${`${LayoutConst.screen.m}px`}) {
    //     display: inline-flex;
    //     white-space: pre-wrap;
    // }
`

export const DesignerSocialNetworkIcon = styled.div`
    display: flex;
    box-sizing: border-box;
    cursor: pointer;
    align-items: center;
    color: ${({theme}) => theme.link.default};


    svg {
      width: 24px;
      height: 24px;
      * {
        fill: ${({theme}) => theme.link.default};
      }
    }

    &:hover {
        color: ${({theme}) => theme.link.hover};
        ${URL} {
          color: ${({theme}) => theme.link.hover};
        }
        svg {
            * {
                    fill: ${({theme}) => theme.link.hover};
            }
        }
    }
`;

export const SliderGradient = styled.div<{blackBG: boolean}>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    width: 22%;
    z-index: 2;
    height: 35px;
    background: ${p => p?.blackBG ? 'linear-gradient(270deg, rgba(33,37,41,0.1) 55% , rgba(33,37,41, 0) 100%);' : 'linear-gradient(270deg, rgba(255, 255, 255, 0.8) 55.21%, rgba(255, 255, 255, 0) 100%);'};

`;

export const MergeAccountsWrapper = styled(FlexBox)`
    position: absolute;
    top: -12px;
    right: calc((1152px - 100vw + 64px)/2);
    padding: 8px 16px 8px 16px;
    border-radius: 8px;
    gap: 8px;
    align-items: center;
    margin-left: 10px;
    background: ${(p) => p.theme.designerEdit.aboutProfile.bg};

    a {
        color: ${(p) => p.theme.designerEdit.inputs.labelColor};
        font-size: 17px;
        font-weight: 600;
        line-height: 22px;
        letter-spacing: -0.02em;
        text-align: left;
    }

    @media(max-width: 1440px) {
        right: calc((1152px - 100vw + 54px)/2);
    }
`;

export const ProfileAbsoluteMoreContainer = styled(FlexBox)`
    position: absolute;
    left: 13px;
    top: 11px;

    svg path {
        fill: #fefefe !important;
    }
`;

export const MobileButton = styled(FlexBox)`
    width: 100%;
    button {
    height: 36px !important; 
    width: 100%;
    max-width: 100% !important;
    margin: 0 !important;
    }
`;

import ShowMoreText from 'react-show-more-text';
import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox, INTER } from '@brg/ui';
import { LayoutConst } from "../../../core";

export const ShowMoreContent = styled(ShowMoreText)<{importantStyles?: boolean, isOnlines?: boolean, breakSpace?: boolean, designer?: boolean }>`
        flex-direction: column;
        width: 100%;
        
        font-size: 20px;
        line-height: 28px;

        a {
            // color: ${p =>  p.theme.designerPage.noProjectBlock.avatar.bg};
            color: #909090;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            font-style: normal;
            transition: color 0.2s;

                &:hover {
                // color: ${({ theme }) => theme?.navigationBar?.btns?.showMore?.hover?.color || Colors.geoWhite47};
                color: #545453;
                transition: color 0.2s;
            }
        }
        @media(max-width: ${LayoutConst.screen.l}px) {
           &, & a {
                font-size: 17px;
                line-height: 22px;
           }            
        }
        ${({designer}) => designer && css`
            @media(max-width: ${LayoutConst.screen.m}px) {
                // width: 680px;
                min-width: auto;
            }
            @media(max-width: ${LayoutConst.screen.sm}px) {
                width: 100%;
            }
        `}
         
    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-style: normal;
        color: ${({ theme }) => theme.app.text};
        ${p => p.breakSpace && css`
            white-space: break-spaces;
        `};
         &:last-of-type {
            white-space: normal;
        }
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        ${p => p.importantStyles ? css`
            span {
                font-size: 17px;
                line-height: 22px;
                font-family: 'Inter';
                font-weight: 400;
            }
        `: null};
        ${p => p.isOnlines ? css`
            span {
                font-weight: 500;
                font-style: normal;
                color: rgba(0, 0, 0, 1);
                font-family: Montserrat;
                font-size: 20px;
                letter-spacing: 0px;
                line-height: 28px;
            }
        `: null}

        ${p => p.isOnlines ? css`
        span {
            font-weight: 500;
            font-style: normal;
            color: rgba(0, 0, 0, 1);
            font-family: Montserrat;
            font-size: 20px;
            letter-spacing: 0px;
            line-height: 28px;
        }
    `: null}
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;

        &, & a, & span {
           font-size: 15px;
           line-height: 20px;
        }
    }
`;

export const LinkWrapper = styled.div`
    &:hover {
        svg path {
            fill: ${p => p?.theme.designerPage.textColor};
            transition: 0.2s fill;
        }
    }
`;

export const AboutTextWrapper = styled(FlexBox)<{isLoading?: boolean}>`
`;

export const ProfileTitleSubtitle = styled.div`
  margin-top: 8px;
  color: ${Colors.galBlack100};
  ${INTER.F_17_22_Reg};
  letter-spacing: -0.34px;
`;

export const ProfileTitleSubtitleBold = styled.span`
  font-weight: 600;
`;

export const AboutText = styled(FInter.TextDiv)`
        width: 100%;
        font-size: 17px;
        line-height: 22px;
        margin-top: 24px;
        a {
            font-size: 17px;
            line-height: 22px;
        }
        
        @media (max-width: ${LayoutConst.screen.l}px){
                font-size: 13px;
                line-height: 16px;
                font-weight: 400;
                a {
                    font-size: 13px;
                    line-height: 16px;
                }
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px){
            margin-top: 16px;
        }
`

export const URL = styled(FInter.SmallTextBold)`
    display: none;
    color: ${({theme}) => theme.link.default};
    margin-left: 4px;
    font-size: 17px;
    line-height: 22px;
    // @media (max-width: ${`${LayoutConst.screen.m}px`}) {
    //     display: inline-flex;
    //     white-space: pre-wrap;
    // }
`

export const DesignerSocialNetworkIcon = styled.div`
    display: flex;
    box-sizing: border-box;
    cursor: pointer;
    align-items: center;
    color: ${({theme}) => theme.link.default};


    svg {
      width: 24px;
      height: 24px;
      * {
        fill: ${({theme}) => theme.link.default};
      }
    }

    &:hover {
        color: ${({theme}) => theme.link.hover};
        ${URL} {
          color: ${({theme}) => theme.link.hover};
        }
        svg {
            * {
                    fill: ${({theme}) => theme.link.hover};
            }
        }
    }
`;

export const SliderGradient = styled.div<{blackBG: boolean}>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    width: 22%;
    z-index: 2;
    height: 35px;
    background: ${p => p?.blackBG ? 'linear-gradient(270deg, rgba(33,37,41,0.1) 55% , rgba(33,37,41, 0) 100%);' : 'linear-gradient(270deg, rgba(255, 255, 255, 0.8) 55.21%, rgba(255, 255, 255, 0) 100%);'};

`;

export const MergeAccountsWrapper = styled(FlexBox)`
    position: absolute;
    top: -12px;
    right: calc((1152px - 100vw + 64px)/2);
    padding: 8px 16px 8px 16px;
    border-radius: 8px;
    gap: 8px;
    align-items: center;
    margin-left: 10px;
    background: ${(p) => p.theme.designerEdit.aboutProfile.bg};

    a {
        color: ${(p) => p.theme.designerEdit.inputs.labelColor};
        font-size: 17px;
        font-weight: 600;
        line-height: 22px;
        letter-spacing: -0.02em;
        text-align: left;
    }

    @media(max-width: 1440px) {
        right: calc((1152px - 100vw + 54px)/2);
    }
`;

export const ProfileAbsoluteMoreContainer = styled(FlexBox)`
    position: absolute;
    left: 13px;
    top: 11px;

    svg path {
        fill: #fefefe !important;
    }
`;

export const MobileButton = styled(FlexBox)`
    width: 100%;
    button {
    height: 36px !important; 
    width: 100%;
    max-width: 100% !important;
    margin: 0 !important;
    }
`;